import { useCallback } from 'react';
import { useAutoZoomToHomeAor } from 'components/MapPage/CorporateViewTabs/AorsTab/utils/useAutoZoomToHomeAor';
import { useUscgMapContext } from 'components/MapPage/CorporateViewTabs/LayersTab/UscgMapContext';

/**
 * Zooms the map to a report's AOR and turns the AOR layer on, widening the AOR
 * filter when the AOR is currently filtered out.
 */
const useZoomToReportAor = () => {
  const { zoomToAorById } = useAutoZoomToHomeAor();
  const { aorFilterIds } = useUscgMapContext();

  return useCallback(
    (aorId: string) => {
      const isFilteredOut =
        aorFilterIds !== null && !aorFilterIds.includes(aorId);
      return zoomToAorById(aorId, {
        ensureVisible: true,
        ...(isFilteredOut ? { filterIds: [...aorFilterIds, aorId] } : {}),
      });
    },
    [aorFilterIds, zoomToAorById]
  );
};

export default useZoomToReportAor;
